import React from "react";

function HighlightQuery({ text, query }) {
	if (!query) {
		return <span>{text}</span>;
	}

	const startIndex = text.toLowerCase().indexOf(query.toLowerCase());

	if (startIndex === -1) {
		return <span>{text}</span>;
	}

	const before = text.substring(0, startIndex);
	const matched = text.substring(startIndex, startIndex + query.length);
	const after = text.substring(startIndex + query.length);

	return (
		<span>
			{before}
			<span className="text-black">{matched}</span>
			{after}
		</span>
	);
}

export default HighlightQuery;
